import type { FC } from 'react';
import { CircleHelp } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';

export const CancerScreeningNotScreenedBadge: FC = () => {
  const { t } = useTranslation(['component']);

  return (
    <Badge className="border-transparent bg-warning text-white">
      <CircleHelp className="size-3" />
      {t('component:badge.cancerScreeningNotScreened')}
    </Badge>
  );
};
